import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export interface GuestIdentityUser {
  id: null
  guest: true
  admin: boolean
  screen_name: null
  email: null
  newsletter_opt_in: false
}

export interface AuthenticatedIdentityUser {
  id: number
  guest: false
  admin: boolean
  screen_name: string
  email: string
  newsletter_opt_in: boolean
}

export type IdentityUser = GuestIdentityUser | AuthenticatedIdentityUser

export const useIdentityKey = ['useIdentity']

export default function useIdentity(options = {}) {
  return useQuery<IdentityUser>(
    useIdentityKey,
    async () => {
      const response = await axios.get<IdentityUser>(
        '/api/spoonflower/user/identity',
        { withCredentials: true }
      )
      return response.data
    },
    options
  )
}